import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCb = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 15,
	viewBox: "0 0 22 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M21.0645 0.0915527H1.60778C1.09117 0.0915527 0.672363 0.510355 0.672363 1.02697V13.7487C0.672363 14.2653 1.09117 14.6841 1.60778 14.6841H21.0645C21.5811 14.6841 22 14.2653 22 13.7487V1.02697C22 0.510355 21.5811 0.0915527 21.0645 0.0915527Z",
			fill: "url(#paint0_linear_5142_2317)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.65199 7.16604H11.5904C11.5642 6.53089 11.4162 5.87606 10.9674 5.45545C10.4327 4.9544 9.49622 4.76855 8.65943 4.76855C7.78848 4.76855 6.8253 4.9724 6.28781 5.50997C5.82432 5.97308 5.72412 6.71816 5.72412 7.38758C5.72412 8.08881 5.92015 8.90446 6.42295 9.3743C6.9576 9.87419 7.82395 10.0069 8.65943 10.0069C9.47108 10.0069 10.3503 9.85706 10.8818 9.38246C11.4119 8.90839 11.595 8.10991 11.595 7.38758V7.38422H8.65199V7.16604ZM11.7876 7.38433V9.88979H15.8752V9.88639C16.4733 9.8538 16.9492 9.31451 16.9492 8.65238C16.9492 7.98996 16.4733 7.41609 15.8752 7.3832V7.38433H11.7876ZM15.8287 4.87347C16.4116 4.87347 16.8743 5.37927 16.8743 6.01753C16.8743 6.62173 16.4494 7.11519 15.9088 7.16607H11.7876V4.8698H15.6997C15.7238 4.86685 15.7518 4.86894 15.7793 4.87096C15.7964 4.8722 15.8132 4.87347 15.8287 4.87347Z",
			fill: "#FEFEFE"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_5142_2317",
			x1: 6.37166,
			y1: -1.99081,
			x2: 1.09769,
			y2: 14.1993,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#222E72" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .591647,
					stopColor: "#40CBFF"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#3CB792"
				})
			]
		}) })
	]
});
export default SvgCb;
